<template>
	<div class="album-container">
		<a-spin :spinning="loading">
			<a-tabs v-model="activeKey" type="card" @change="tabChange">
				<a-tab-pane key="album" tab="手册列表">
					<div class="album-content">
						<div class="p-bottom-20">
							<a-select class="width-160 m-right-20" v-model="klassId" placeholder="请选择班级" @change="klassChange">
								<a-select-option v-for="item in klassList" :value="item.id" :key="item.id">
									{{ item.name }}
								</a-select-option>
							</a-select>
							<a-select class="width-160" v-model="studentId" placeholder="请选择学生" allowClear
								@change="changeStudent">
								<a-select-option v-for="item in studentList" :value="item.id" :key="item.id">
									{{ item.kid_name }}
								</a-select-option>
							</a-select>
							<a-button class="fr" icon="plus" @click="showCreateModal">创建手册</a-button>
						</div>
						<a-table :columns="columns" :data-source="albumList"
							:rowKey="(record, index) => `${index}_${record.id}`" :pagination="false" bordered>
							<template slot="operation" slot-scope="text, record">
								<div class="album-table_btn">
									<a class="album-table_btn" v-if="record.status === 'FINALIZED'" href="javascript:;"
										@click="generateALbumHandle(record)">
										<svg-icon iconClass="publish_icon"></svg-icon>
										<span class="album-table_btn_text">生成电子版</span>
									</a>
									<a class="album-status_success album-table_btn" v-else-if="record.status === 'GENERATED'"
										href="javascript:;" @click="generateALbumHandle(record)">点击下载</a>
									<span class="album-status_disabled  album-table_btn" v-else href="javascript:;">生成电子版</span>
									<a class="album-table_btn del-color m-left-20" href="javascript:;"
										@click="delHandle(record)" v-if="record.id">
										<svg-icon iconClass="delete"></svg-icon>
										<span class="album-table_btn_text">删除</span>
									</a>
								</div>
							</template>
							<template slot="albumName" slot-scope="albumName, record">
								<a v-if="record.id" href="javascript:;" @click="viewAlbum(record)">{{ albumName }}</a>
								<span v-else>暂无手册</span>
							</template>
						</a-table>
					</div>
				</a-tab-pane>
				<a-tab-pane key="albumTemp" tab="手册模板">
					<album-temp />
				</a-tab-pane>
			</a-tabs>



			<a-modal title="创建手册" v-model="modalInfo.visible" :confirm-loading="modalInfo.loading" @ok="confirmHandle">
				<span class="album-modal_label m-bottom-30">选择学生：</span>
				<a-select class="album-modal_input" v-model="modalInfo.studentId" placeholder="请选择学生" allowClear>
					<a-select-option v-for="item in studentList" :value="item.id" :key="item.id">
						{{ item.kid_name }}
					</a-select-option>
				</a-select>
				<span class="album-modal_label">选择模板：</span>
				<a-select class="album-modal_input" v-model="modalInfo.albumTempId" placeholder="请选择模板" allowClear>
					<a-select-option v-for="item in albumTempList" :value="item.id" :key="item.id">
						{{ item.title }}
					</a-select-option>
				</a-select>
			</a-modal>
		</a-spin>
	</div>
</template>
  
<script>
import { mapGetters } from "vuex";
import StudentService from "@/api/studentService";
import AlbumService from "@/api/albumService";
import { getAlbumColumns } from "./constant";
import { getAlbumDigtalHandle } from "@/utils/albumDigtal";
import AlbumTemp from "./albumTemp";

export default {
	name: "klassCircle",
	components: { AlbumTemp },
	data() {
		return {
			activeKey: "album",
			columns: getAlbumColumns(),
			albumList: [],
			albumTempList: [],
			studentList: [],
			loading: false,
			studentId: undefined,
			klassId: undefined,
			modalInfo: {},
		};
	},

	computed: {
		...mapGetters(["klassList"]),
	},

	created() {
		this.initHandle();
	},

	methods: {
		initHandle() {
			this.studentId = this.$route.query.student_id;
			this.klassId = this.$route.query.klass_id;
			this.activeKey = this.$route.query.type || "album";
			this.getKlassList();
		},
		
		tabChange() {
			this.$router.replace({
				name: "album",
				query: { ...this.$route.query, type: this.activeKey },
			});
			this.studentId = undefined;
			this.getStudentList();
			this.getAlbumTempList();
		},

		
		klassChange() {
			this.$router.replace({
				name: "album",
				query: { ...this.$route.query, klass_id: this.klassId },
			});
			this.studentId = undefined;
			this.getStudentList();
			this.getAlbumTempList();
		},

		changeStudent() {
			if (!this.studentId) {
				this.albumList = [...this.originAlbumList];
			} else {
				this.albumList = this.originAlbumList.filter(
					(album) => album.student_id === this.studentId
				);
			}

			const query = { ...this.$route.query, klass_id: this.klassId };
			if (this.studentId) {
				query.student_id = this.studentId;
			}
			this.$router.replace({ name: this.$route.name, query })
		},

		getKlassList(isForce = false) {
			this.$store
				.dispatch("getKlassListService", { isForce })
				.then((res) => {
					this.klassId =
						this.$route.query.klass_id || (res[0] || {}).id;
					this.getAlbumTempList();
					this.getStudentList();
				});
		},

		getAlbumTempList() {
			AlbumService.getAlbumTempListService({
				klass_id: this.klassId,
			})
				.then((res) => {
					this.albumTempList = res || [];
				})
		},

		getStudentList() {
			this.loading = true;
			StudentService.getStudentListService({
				klass_id: this.klassId,
			})
				.then((res) => {
					this.studentList = (res || []).filter(student => {
						return student.kinsfolk_info_from_teacher_list.filter(item => item.status === "ACCEPTED").length > 0;
					});
					if (this.studentList.length) {
						this.getAlbumList();
					} else {
						this.originAlbumList = [];
						this.changeStudent();
						this.loading = false;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},

		getAlbumList() {
			this.loading = true;
			AlbumService.getAlbumListService({ klass_id: this.klassId })
				.then((res) => {
					const studentIds = this.studentList.map(item => item.id);
					let albumList = (res || []).reverse();
					albumList = albumList.filter(item => studentIds.includes(item.student_id)).sort((a, b) => a.student_id.localeCompare(b.student_id));
					let studentId = undefined;
					const studentList = [];
					albumList.map((album) => {
						album.studentName =
							(
								this.studentList.find(
									(student) => student.id === album.student_id
								) || {}
							).kid_name || "--";
						if (studentId !== album.student_id) {
							studentId = album.student_id;
							album.rowSpan = albumList.filter(item => item.student_id === studentId).length;
							studentList.push(studentId);
						}
						return album;
					});
					this.studentList.forEach(student => {
						if (!studentList.includes(student.id)) {
							albumList.push({
								student_id: student.id,
								studentName: student.kid_name,
								rowSpan: 1,
							})
						}
					})
					this.originAlbumList = albumList;
					this.changeStudent();
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},

		delHandle(record) {
			this.$confirm({
				title: "提示信息",
				content: `是否删除当前手册 ${record.title}`,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						AlbumService.delAlbumService({ albumId: record.id })
							.then(() => {
								this.$message.success("操作成功");
								this.getAlbumList();
								resolve();
							})
							.catch(() => {
								reject();
								this.$message.error("操作失败，请重新操作");
							});
					});
				},
			});
		},

		showCreateModal() {
			this.modalInfo = {
				loading: false,
				visible: true,
			};
		},

		confirmHandle() {
			this.modalInfo.loading = true;
			const { studentId, albumTempId } = this.modalInfo;
			const albumTemp = this.albumTempList.find(item => item.id === albumTempId);
			const params = {
				"title": albumTemp.title,
				"klass_id": this.klassId,
				"student_id": studentId,
				"template_id": albumTempId,
			}
			AlbumService.createAlbumService(params).then((res) => {
				this.$message.success("操作成功");
				this.updateAlbumBody(res.id, albumTemp);
			})
				.catch(() => {
					this.modalInfo.loading = false;
					this.$message.error("操作失败，请重新操作");
				});
		},

		updateAlbumBody(albumId, albumTemp) {
			const pageViews = [];
			for (let i = 0; i < albumTemp.page_views.length; i++) {
				const { background_image, section_views, id, ...others } = albumTemp.page_views[i];
				const pageView = { background_image_id: background_image.id, template_page_id: id, sections: [], id: i + 1, ...others };
				for (let j = 0; j < section_views.length; j++) {
					const { field_views } = section_views[j];
					const fields = []
					for (let k = 0; k < field_views.length; k++) {
						const { default_image, default_style, default_value, type, ...params } = field_views[k];
						const field = { ...params, type, style: default_style, template_field_id: field_views[k].id };
						if (type === "image") {
							field.image_id = default_image ? default_image.id : null;
						} else {
							field.value = default_value || null;
						}
						fields.push(field);
					}
					pageView.sections.push({ template_section_id: section_views[j].id, fields });
				}
				pageViews.push(pageView);
			}


			AlbumService.updateAlbumBodyService({ albumId, albumBody: { pages: pageViews } }).then(() => {
				this.modalInfo.loading = false;
				this.$router.push({ name: "albumDetail", query: { id: albumId, klass_id: this.klassId, student_id: this.modalInfo.studentId } });
			}).catch(() => {
				this.modalInfo.loading = false;
				this.$message.error("操作失败，请重新操作");
			});
		},

		async generateALbumHandle(record) {
			if (record.status === "GENERATED") {
				window.open(record.digital_copy.url, "_blank");
				return;
			}

			let content = `是否生成当前手册 《${record.title}》`;
			if (record.status === "GENERATION_FAILED") {
				content = `是否重新生成当前手册 《${record.title}》`;
			}
			const albumBody = await this.getAlbumBodyHandle(record);
			const html_content = getAlbumDigtalHandle(albumBody.page_views);
			this.$confirm({
				title: "提示信息",
				content,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						AlbumService.createAlbumDigitalService({ albumId: record.id, html_content })
							.then(() => {
								this.$message.success("操作成功");
								this.getAlbumList();
								resolve();
							})
							.catch(() => {
								reject();
								this.$message.error("操作失败，请重新操作");
							});
					});
				},
			});
		},

		async getAlbumBodyHandle(record) {
			const result = await AlbumService.getAlbumBodyService({ albumId: record.id });
			return result;
		},

		viewAlbum(album) {
			this.$router.push({ name: "albumDetail", query: { id: album.id, klass_id: album.klass_id, student_id: album.student_id } });
		}
	},
};
</script>
  
<style lang="less" scoped>
.album {
	&-container {
		background: #ffffff;
		min-height: calc(100% - 65px);
		margin-top: 15px;

		/deep/.ant-tabs-nav-scroll {
			background: #f0f2f5;
		}

		/deep/.ant-tabs-tab {
			border: none !important;
			margin: 0 !important;
		}

		/deep/.ant-tabs-bar {
			margin-bottom: 0;
		}
	}

	&-content {
		padding: 28px 28px 2px 30px;
	}

	&-table {
		&_btn {
			display: flex;
			flex-flow: nowrap row;
			align-items: center;
			justify-content: center;
			line-height: 1;

			&_text {
				margin-left: 5px;
				line-height: 1;
			}

			&_disabled {
				cursor: not-allowed;
				color: rgba(0, 0, 0, 0.25);
				border-color: #d9d9d9;
			}
		}
	}

	&-modal {
		&_label {
			display: inline-block;
			width: 85px;
			height: 20px;
			font-size: 14px;
			color: #3d3d3d;
			font-weight: bold;
		}

		&_input {
			width: 360px;
			height: 32px;
			border-radius: 4px;
			border-color: #d5d5d5;
		}
	}

	&-status {
		&_disabled {
			color: #a9a9a9;
		}

		&_success {
			color: #1ab752;
		}

		&_fail {
			color: #fe5c73;
		}

		&_ing {
			color: #ffa647;
		}
	}
}
</style>
